import * as React from 'react';

const InfoIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36.083}
    height={36.083}
    viewBox="0 0 36.083 36.083"
    {...props}
  >
    <defs>
      <linearGradient id="a" x1={0.5} x2={0.5} y2={1} gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#d3793b" />
        <stop offset={1} stopColor="#ea4154" />
      </linearGradient>
    </defs>
    <g data-name="noun_Info_4147437 (1)">
      <g data-name="Group 1079">
        <g data-name="Group 1076">
          <path
            data-name="Path 652"
            d="M50.083 32.441A17.541 17.541 0 1 1 32.541 14.9a17.561 17.561 0 0 1 17.542 17.541Zm-3.007 0a14.534 14.534 0 1 0-14.535 14.534 14.545 14.545 0 0 0 14.534-14.534Z"
            transform="translate(-14.5 -14.4)"
            stroke="#fff"
            fill="url(#a)"
          />
        </g>
        <g data-name="Group 1077">
          <path
            data-name="Path 653"
            d="M48.5 44.8a1.477 1.477 0 0 0-1.5 1.5v7.668a1.5 1.5 0 0 0 3.007 0V46.3a1.477 1.477 0 0 0-1.507-1.5Z"
            transform="translate(-30.462 -29.315)"
            stroke="#fff"
            fill="url(#a)"
          />
        </g>
        <g data-name="Group 1078">
          <path
            data-name="Path 654"
            d="M48.5 33.8a1.542 1.542 0 0 0-1.5 1.5.636.636 0 0 0 .05.3.712.712 0 0 0 .1.3c.05.1.1.15.15.251a.88.88 0 0 0 .2.251 1.546 1.546 0 0 0 2.1 0 1.093 1.093 0 0 0 .2-.251c.05-.1.1-.15.15-.251s.05-.2.1-.3c0-.1.05-.2.05-.3a1.365 1.365 0 0 0-.451-1.052A1.766 1.766 0 0 0 48.5 33.8Z"
            transform="translate(-30.462 -23.828)"
            stroke="#fff"
            fill="url(#a)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default InfoIcon;
